export class DeleteQBEntriesForMoovStepInstanceRequest{
    public requestorId!:number;
    public moovStepInstanceId!:number;
    public requestorCustomerId!:number;
    public clientId!:number;
}